import { NovaObraData } from "@/hooks/useNovaObra";
import { supabase } from "@/integrations/supabase/client";
import {
  listObrasFromSupabase,
  createObraInSupabase,
  deleteObraFromSupabase,
  updateObraInSupabase,
} from "@/services/obrasSupabaseService";

export type ObraRecord = NovaObraData & {
  id: string;
  createdAt: string;
  updatedAt: string;
};

// Store em memória, hidratado do Supabase (fonte de verdade = tabela `obras`).
// Mantém a API síncrona usada por vários componentes (getObraById em render).
let _obras: ObraRecord[] = [];

export async function hydrateObras(): Promise<void> {
  try {
    _obras = await listObrasFromSupabase();
  } catch (e) {
    console.error("hydrateObras:", e);
  }
}

export function saveObra(data: NovaObraData): ObraRecord {
  const now = new Date().toISOString();
  const temp: ObraRecord = { ...data, id: `tmp-${Date.now()}`, createdAt: now, updatedAt: now };
  _obras = [temp, ..._obras];
  (async () => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;
    try {
      const created = await createObraInSupabase(data, user.id);
      _obras = _obras.map((o) => (o.id === temp.id ? created : o));
    } catch (e) {
      console.error("saveObra:", e);
    }
  })();
  return temp;
}

export function updateObra(id: string, updates: Partial<ObraRecord>): ObraRecord | undefined {
  const current = _obras.find((o) => o.id === id);
  if (!current) return undefined;
  const merged: ObraRecord = { ...current, ...updates, updatedAt: new Date().toISOString() };
  _obras = _obras.map((o) => (o.id === id ? merged : o));
  (async () => {
    try {
      await updateObraInSupabase(id, merged);
    } catch (e) {
      console.error("updateObra:", e);
    }
  })();
  return merged;
}

export const listObras = (): ObraRecord[] => _obras;

export const getObraById = (id: string): ObraRecord | undefined => _obras.find((o) => o.id === id);

export const deleteObra = (id: string): void => {
  _obras = _obras.filter((o) => o.id !== id);
  (async () => {
    try { await deleteObraFromSupabase(id); } catch (e) { console.error("deleteObra:", e); }
  })();
};

